//@mui/material

import { Box, Pagination, useMediaQuery, useTheme } from "@mui/material";

//hooks
import useIsMobile from "../../../../hooks/useIsMobile";

//components
import HeadlineNewsCard from "./HeadlineNewsCard";
import HeroSkeleton from "../../../Carousel/HeroSkeleton";
import ImageInfoCard from "../../../NewsCard/ImageInfoCard";
import NewsDeploymentCard from "./NewsDeploymentCard";
import LikeAndDislike from "../../../LikeAndDislike/LikeAndDislike";

const PaginationNews = ({ dataInformation = null, pageNumber, setPaginationModel, setPageNumber }) => {
    const addFixed = useIsMobile() ? 8 : 16;

    const theme = useTheme();
    const isScreenXS = useMediaQuery(theme.breakpoints.only("xs"));

    const handlePageChange = (event, value) => {
        setPageNumber(value);
        setPaginationModel((prevModel) => ({
            ...prevModel,
            page: value,
        }));
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    if (!dataInformation?.data) {
        return <HeroSkeleton />;
    }
    const renderImageInfoCard = (item) => {
        return isScreenXS ? (
            <NewsDeploymentCard
                item={item}
                logo={
                    item?.scrape?.link_logo
                        ? item.scrape.link_logo
                        : item?.rss?.link_logo
                          ? item?.rss?.link_logo
                          : ""
                }
                source={
                    item?.scrape?.channel
                        ? item.scrape.channel
                        : item?.rss?.channel
                          ? item?.rss?.channel
                          : ""
                }
                tags={item?.tags}
            />
        ) : (
            <ImageInfoCard
                id={item.id}
                title={item?.title}
                content={item?.content}
                countLikes={item?.likes}
                countDislikes={item?.dislikes}
                image={item?.image ? item?.image : ""}
                link={item?.link}
                tags={item?.tags}
                logo={
                    item?.scrape?.link_logo
                        ? item.scrape.link_logo
                        : item?.rss?.link_logo
                          ? item?.rss?.link_logo
                          : ""
                }
                source={
                    item?.scrape?.channel
                        ? item.scrape.channel
                        : item?.rss?.channel
                          ? item?.rss?.channel
                          : ""
                }
                options={{
                    height: "230px",
                    sourceSize: { xl: "16px", lg: "16px", xs: "13px", sm: "13px" },
                    likeCtGap: { xl: "10px", lg: "10px", xs: "0", sm: "0" },
                    buttonLikeSize: { xl: "unset", lg: "unset", xs: "17px", sm: "17px" },
                    titleSize: { xl: "18px", lg: "18px", xs: "16px", sm: "16px" },
                    contentSize: { xl: "1rem", lg: "1rem", xs: "15px", sm: "15px" },
                }}
            />
        );
    };

    return (
        <Box>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr 1fr",
                        sm: "1fr 1fr",
                        lg: "1fr 1fr 1fr 1fr",
                    },
                    gap: "1px",
                    width: "100%",
                    marginBottom: "10px",
                }}
            ></Box>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "1fr 1fr 1fr",
                        lg: "1fr 1fr 1fr 1fr",
                    },
                    columnGap: "10px",
                    rowGap: "10px",
                    width: "100%",
                    marginBottom: "10px",
                }}
            >
                {dataInformation?.data?.map((item, i) => {
                    return (
                        <div key={i}>
                            {renderImageInfoCard(item)}
                            {/*<Box sx={{
                            display: 'flex'
                        }}>
                            <LikeAndDislike item={item} sx={{
                                marginLeft: 'auto',
                                marginRight: 'auto'
                            }}/>
                        </Box>*/}
                        </div>
                    );
                    // Descomentar para usar con publicidad
                    /*return (
                    ((i) % addFixed == 0 && i != 0)
                    ?   <>
                            <Box sx={{width: "100%", height: "200px", background: "red", gridColumn: {xl: "span 4", lg: "span 4", xs: "span 2", sm: "span 2"}}}>
                                Publicidad Aqui
                            </Box> 
                            {renderImageInfoCard(item)}
                        </>
                    : renderImageInfoCard(item)
                    )*/
                })}
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                <Pagination
                    count={dataInformation?.pagination?.pageCount}
                    page={pageNumber}
                    onChange={handlePageChange}
                    color="primary"
                    variant="outlined"
                />
            </Box>
        </Box>
    );
};

export default PaginationNews;
